export default {
  warranty: {
    id: 'cms_products_warranty',
    defaultMessage: '{duration} months',
  },
}
